/* eslint-disable react/prop-types */
import { PageWrapper } from '@styles/base.styled'
import MobileDetect from 'mobile-detect'
import React from 'react'
import { allSettled } from 'effector'
import { initGroupGoods } from 'src/features/goods-groups-update/model'
import { setPageState } from '@entities/route/model'
import { createGSSP, pageStarted } from 'src/pages/shared/bindings'
import { setCurrentGroupId } from '@entities/groups/model'
import { initShipmentGSSP } from '@entities/shipment/init-gssp'
import dynamic from 'next/dynamic'

const MobileGroupPage = dynamic(() =>
    import('../../src/components/mobilePages/catalog/MobileGroupPage/MobileGroupPage')
)
const Group = dynamic(() => import('../../src/components/Group/Group'))
export default function Group2Index(props) {
    if (props.mobile) {
        return <MobileGroupPage groupId={props.groupId} groupPosition="group1" />
    }
    return (
        <PageWrapper>
            <Group groupId={props.groupId} />
        </PageWrapper>
    )
}

export const getServerSideProps = createGSSP({
    // Will be called on each page navigation (always on server side)
    // Always called after shared events
    pageEvent: pageStarted,

    // You can define your custom logic using "customize" function
    // It's run after all events are settled, but before Scope serialization
    // So, here you can safely call allSettled

    async customize({ scope, context }) {
        const md = new MobileDetect(context.req.headers['user-agent'])
        const groupId = parseInt(context.params.group1, 10)
        await initShipmentGSSP(scope, context)
        await allSettled(setCurrentGroupId, { scope, params: groupId })
        await allSettled(setPageState, {
            scope,
            params: {
                isCatalogPage: true,
                isSearchPage: false
            }
        })
        await allSettled(initGroupGoods, { scope, params: { groupId, ctx: context } })
        return {
            props: {
                groupId,
                mobile: md.mobile()
            }
        }
    }
})
